export enum TriggerConditions {
  EQUAL = 'equal',
  NOTEQUAL = 'notEqual',
  SMALLER = 'smaller',
  GREATER = 'greater',
  GREATEREQUAL = 'greaterEqual',
  SMALLEREQUAL = 'smallerEqual',
}
